<template>
  <b-container fluid>
    <h3 class="mt-3 mb-3">Users</h3>

    <div class="action_bar mb-3">
      <b-button
        class="btn-action-lg"
        size="sm"
        variant="info"
        :to="{name: 'user_manage'}"
      >Manage Users</b-button>
    </div>

    <div class="search_bar mb-3">
      <b-row>
        <b-col cols="1" class="pr-0">
          <b-form-select
            size="sm"
            v-model="search_criteria.account_type"
            :options="account_type_options"
          />
        </b-col>
        <b-col cols="2" class="pl-1 pr-1">
          <b-form-input
            id="input-small"
            size="sm"
            type="text"
            placeholder="Name / Phone"
            v-model="search_criteria.keyword"
          ></b-form-input>
        </b-col>
        <b-col class="text-left p-0">
          <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
            <font-awesome-icon class="mr-1" icon="search" />Search
          </b-button>
        </b-col>
      </b-row>
    </div>

    <b-pagination
      size="sm"
      :total-rows="total_rows"
      v-model="currentPage"
      :per-page="TABLE_LIMIT"
      @change="onPageChange"
      :limit="PAGING_LIMIT"
    ></b-pagination>

    <b-table small outlined striped hover :items="items" :fields="fields">
      <template v-slot:cell(action)="data">
        <b-button
          class="btn-action"
          size="sm"
          variant="info"
          @click.stop="showModal_change_password(data.item)"
        >
          Change Password
        </b-button>

        <b-button
          class="btn-action"
          size="sm"
          variant="danger"
          @click.stop="showModal_delete_confirm(data.item)"
        >
          <font-awesome-icon class="mr-1" icon="trash-alt" />Delete
        </b-button>
      </template>
    </b-table>

    <b-pagination
      size="sm"
      :total-rows="total_rows"
      v-model="currentPage"
      :per-page="TABLE_LIMIT"
      @change="onPageChange"
      :limit="PAGING_LIMIT"
    ></b-pagination>

    <b-modal ref="modal_delete_confirm" centered hide-footer hide-header>
      <div class="d-block">Are you sure to delete this record?</div>
      <div class="text-right">
        <b-btn class="mt-3" variant="outline-danger" @click="hideModal_delete_confirm">No</b-btn>
        <b-btn class="mt-3" variant="outline-success" @click="confirmDelete()">Yes</b-btn>
      </div>
    </b-modal>

    <b-modal ref="modal_change_password" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col><strong>Username:</strong> {{updating_item.name}}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>New Password:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-input id="reschedule_delivery_date" type="text" v-model="change_password"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_change_password">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="confirmChangePassword()">Confirm</b-btn>
        </div>
      </b-modal>
  </b-container>
</template>

<script>
import TextCollapse from "@/components/TextCollapse.vue";

const fields = [
  {
    key: "id",
    label: "ID"
  },
  {
    key: "account_type",
    label: "Account Type"
  },
  {
    key: "username",
    label: "Username"
  },
  {
    key: "name",
    label: "Name"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "action",
    label: "Action"
  }
];

const account_type_options = [
  {
    value: null,
    text: "All Accounts"
  },
  {
    value: "admin",
    text: "Admin"
  },
  {
    value: "cs",
    text: "CS"
  },
  {
    value: "driver",
    text: "Driver"
  }
];

export default {
  name: "Users",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    TextCollapse
  },
  data() {
    return {
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        account_type: null
      },
      showDismissibleAlert: false,
      account_type_options : account_type_options,
      updating_item : false,
      change_password : '',
    };
  },
  async created() {
    await this.getUsers();
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    async getUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria
        }
      });
      this.items = response.data.users;
      this.total_rows = parseInt(response.data.total_rows);

      this.loader.hide();
    },

    onSearch() {
      this.getUsers();
    },

    checkAllRows() {
      console.log("checkAllRows");
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getUsers();
    },

    showModal_delete_confirm(item) {
      this.$refs.modal_delete_confirm.item = item;
      this.$refs.modal_delete_confirm.show();
    },

    hideModal_delete_confirm() {
      this.$refs.modal_delete_confirm.hide();
    },

    showModal_change_password(item) {
      this.updating_item = item;
      this.change_password = "";
      this.$refs.modal_change_password.show();
    },

    hideModal_change_password() {
      this.$refs.modal_change_password.hide();
    },

    async confirmChangePassword() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_change_password.php",
        data: {
          user_id: this.updating_item.id,
          password: this.change_password
        }
      });

      if (response.data.status == "success") {
        this.getUsers();
      } else {
      }

      this.$refs.modal_change_password.hide();
    },

    async confirmDelete() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_delete.php",
        data: {
          driver_id: this.$refs.modal_delete_confirm.item.id
        }
      });

      if (response.data.status == "success") {
        this.getUsers();
      } else {
      }

      this.$refs.modal_delete_confirm.hide();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Users.vue